var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.8973,
    r: 16,
    fill: "#E5EBED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5715 15.9449H21.1429C21.5635 15.9449 21.9048 16.2862 21.9048 16.7068C21.9048 17.1274 21.5635 17.4687 21.1429 17.4687H16.5715V22.0401C16.5715 22.4607 16.2302 22.802 15.8096 22.802C15.389 22.802 15.0477 22.4607 15.0477 22.0401V17.4687H10.4763C10.0557 17.4687 9.71436 17.1274 9.71436 16.7068C9.71436 16.2862 10.0557 15.9449 10.4763 15.9449H15.0477V11.3735C15.0477 10.9529 15.389 10.6116 15.8096 10.6116C16.2302 10.6116 16.5715 10.9529 16.5715 11.3735V15.9449Z",
    fill: "#335C6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.558fbabb42af28fc387357786ad6bee1.svg";
export { ForwardRef as ReactComponent };